import { z } from "zod";
// Enumerations shared by the DB CHECK constraints, the API, the web UI and the
// Android models. Changing one here means a migration + Models.kt update.
export const ProjectStatus = z.enum(["idea", "active", "paused", "done", "dropped"]);
export const Health = z.enum(["on_track", "at_risk", "late", "stalled", "unknown"]);
export const ProjectKind = z.enum(["client", "venture", "internal", "other"]);
export const StepStatus = z.enum(["pending", "active", "done", "skipped"]);
export const TaskStatus = z.enum(["todo", "doing", "blocked", "done", "dropped"]);
export const Priority = z.enum(["low", "medium", "high", "urgent"]);
export const Effort = z.enum(["min15", "hour1", "half_day", "day", "multi_day"]);
export const DueType = z.enum(["soft", "hard"]);
export const SourceKind = z.enum(["text", "url", "file", "email", "note", "chat", "voice"]);
export const SourceStatus = z.enum(["pending", "processing", "processed", "needs_review", "failed"]);
export const Role = z.enum(["admin", "member"]);
export const TokenKind = z.enum(["mobile", "mcp", "cli"]);
export const ActorKind = z.enum(["user", "ai", "mcp", "agent", "system"]);
export const EntitySource = z.enum(["user", "ai", "mcp", "agent"]);
export const Confidence = z.enum(["low", "medium", "high"]);
export const ReportKind = z.enum(["weekly", "monthly", "adhoc"]);
/** "tomorrow" | "next_week" | "next_monday" | "date:YYYY-MM-DD" */
export const PushOption = z.string().regex(/^(tomorrow|next_week|next_monday|date:\d{4}-\d{2}-\d{2})$/);
/** Calendar date (org-local) as YYYY-MM-DD. Never a JS Date on the wire. */
export const DateISO = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "expected YYYY-MM-DD");
//# sourceMappingURL=enums.js.map